import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { Link } from 'react-router-dom';

import { btag, Bus, pushToDataLayer, SiteConfigManager, StorageManager } from '@atlas/core';
import { Button, Label } from '@atlas/ui';

import { isLocalEnv, LocalConfig } from 'common/utils/utils';
import { BASE_PATH, COOKIES_ACCEPTED_EVENT } from 'src/common/constants';
import { hasCustomGTM, initCustomGTM } from 'src/helpers/initCustomGTM';
import useHotjar from 'src/hooks/useHotjar';
import useMetaPixel from 'src/hooks/useMetaPixel';

const isCookiesAllowedKey = 'isCookiesAllowed';

const CookiesPopup = () => {
  const [isCookiesAllowed, setIsCookiesAllowed] = useState(
    StorageManager.getItem(isCookiesAllowedKey),
  );
  const projectId = LocalConfig.get('projectId');
  const { initHotjar } = useHotjar();
  const { initMetaPixel } = useMetaPixel();

  useEffect(() => {
    // if isCookiesAllowed comes from local storage it will have value 'true' or 'false'
    if (isCookiesAllowed === 'true') {
      if (!isLocalEnv && !hasCustomGTM(projectId)) {
        TagManager.initialize({ gtmId: SiteConfigManager.getConfig('config.config.GTM') });
      }

      if (String(projectId) === '296') {
        initMetaPixel(488782233535872);
      }

      if (hasCustomGTM(projectId) && !isLocalEnv) {
        initCustomGTM(projectId);
      }

      pushToDataLayer('homepage', btag);
    }

    initHotjar();
  }, [isCookiesAllowed, initHotjar, projectId, initMetaPixel]);

  const onSetIsCookiesAllowed = isCookiesActive => {
    StorageManager.setItem(isCookiesAllowedKey, isCookiesActive);
    setIsCookiesAllowed(isCookiesActive);
  };

  const onAllowCookies = () => {
    onSetIsCookiesAllowed('true');
    Bus.emit(COOKIES_ACCEPTED_EVENT);
  };

  const onDeclineCookies = () => {
    onSetIsCookiesAllowed('false');
  };

  // if isCookiesAllowed haven't defined
  if (isCookiesAllowed === null) {
    return (
      <div className="popup-container popup-container-cookies">
        <div className="cookies-popup ">
          <div className="cookies-popup-img">
            <img
              alt="cookies"
              loading="lazy"
              src={`${BASE_PATH}/static/assets/svg/cookie-bite-solid-svgrepo-com%201.svg`}
            />
          </div>
          <div className="cookies-popup-text popup-title-content">
            <Label className="main-label" message="cookies" />
            <span className="sub-label">
              <Label message="cookies_we_use" />{' '}
              <Link to="/page/privacy-and-policy">
                <Label message="cookies" />
              </Link>{' '}
              <Label message="cookies_in_order" />
            </span>
          </div>
        </div>
        <div className="sticky-bottom-buttons-container double ">
          <Button label="cookies_decline" onClick={onDeclineCookies} size="big" type="secondary" />
          <Button label="cookies_accept" onClick={onAllowCookies} size="big" type="primary" />
        </div>
      </div>
    );
  }

  return null;
};

export default CookiesPopup;
